import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

// Styled components for the card
const Card = styled.div`
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  max-width: 350px;
  width: 100%;
  text-align: center;
`;

const CardTitle = styled.h2`
  font-family: "Montserrat", sans-serif;
  font-size: 1.8rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 1rem;
`;

const CardDescription = styled.p`
  font-family: "Montserrat", sans-serif;
  font-size: 1rem;
  color: #666;
  margin-bottom: 2rem;
`;

const Price = styled.p`
  font-family: "Montserrat", sans-serif;
  font-size: 1.5rem;
  font-weight: bold;
  color: #ff9999;
  margin-bottom: 1.5rem;
`;

const SubscribeButton = styled(Link)`
  padding: 0.8rem 2rem;
  font-family: "Montserrat", sans-serif;
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
  background-color: #ff9999;
  border: none;
  border-radius: 50px;
  cursor: pointer;

  &:hover {
    background-color: #ff7676;
  }
`;

// SubscriptionCard Component
const TypeCoachingCard = ({ title, description, linkTo }) => {
  return (
    <Card>
      <CardTitle>{title}</CardTitle>
      <CardDescription>{description}</CardDescription>
      <SubscribeButton to={linkTo}> Details</SubscribeButton>
    </Card>
  );
};

export default TypeCoachingCard;
